/**
 * In-memory handoff of the PDF a visitor uploaded for their FREE score so
 * the paid Dashboard can pre-load the SAME file (no re-upload). Module
 * memory survives SPA navigation (hero → pricing → login → dashboard);
 * it is intentionally NOT persisted — a full page reload drops it.
 */
let _pending = null;

export function setPendingFreeAuditPdf(file) {
  _pending = file ? { file, name: file.name, ts: Date.now() } : null;
}

export function peekPendingFreeAuditPdf() {
  return _pending;
}

export function clearPendingFreeAuditPdf() {
  _pending = null;
}
